import {api} from '../helpers/api';
import utils from '../helpers/utils';

export const JWT_REQUEST = 'JWT_REQUEST';
export const JWT_SUCCESS = 'JWT_SUCCESS';
export const JWT_FAILURE = 'JWT_FAILURE';
export const JWT_STATUS = 'JWT_STATUS';

export function jwtRequest() {
  return {
    type: JWT_REQUEST,
  };
}

export function jwtSuccess(result: $TSFixMe) {
  return {
    type: JWT_SUCCESS,
    jwt: result,
  };
}

export function jwtFailure(error: $TSFixMe) {
  return {
    type: JWT_FAILURE,
    jwt_error: error ? error : {},
  };
}

// nock, fetch-mock etc do not have support for
// async action creators when using 'relative urls'. the testhost
// param enables prefixing the hostname for testing,
// eg: http://localhost:3000/login/login-user instead of /login/login-user

/**
 * Dispatches jwtSuccess action after successfully retrieving credit JWT.
 * Dispatches jwtFailure action on failure.
 *
 * @param {string} accountId
 * @return {Promise<>}
 */
export function getJWT(accountId: string) {
  const url = utils.getJWTPath();

  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      account_id: accountId,
      //TODO: csrf
    },
    credentials: 'include',
  };

  return api(url, config, jwtRequest(), jwtSuccess, jwtFailure);
}
